import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "purchase-orders";
function requestApproval(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "approval", "request"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function approve(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "approve"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function disapprove(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "disapprove"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function requestConfirmation(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "confirmation", "request"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function confirm(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "confirm"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function undoConfirmation(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "undo-confirmation"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function sendPartnerCancellationNotice(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner", "cancellation-notice", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function sendPartnerDeletionNotice(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner", "deletion-notice", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function sendPartnerPickupTimeChangeNotice(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "partner", "pickup-time-change-notice", "send"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function duplicate(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "duplicate"]
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function getAll(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function get(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, body) {
	const config = {
		entityPathSegment
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
function put(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
function deletePurchaseOrders(axios, id, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id],
		queryString: buildQueryString(queryStringConfig)
	};

	const routePath = getRoutePath(config);

	return axios.delete(routePath)
		.then(response => response.data);
}
function setContacts(axios, id, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [id, "contacts"]
	};

	const routePath = getRoutePath(config);

	return axios.put(routePath, body)
		.then(response => response.data);
}
export {
	approve,
	confirm,
	deletePurchaseOrders,
	disapprove,
	duplicate,
	get,
	getAll,
	post,
	put,
	requestApproval,
	requestConfirmation,
	sendPartnerCancellationNotice,
	sendPartnerDeletionNotice,
	sendPartnerPickupTimeChangeNotice,
	setContacts,
	undoConfirmation
};
